const formatedTwoDigitsAfterNum = (val) => {
  val = String(val);
  val = val.replace(/([^0-9.]+)/, "");
  val = val.replace(/^(0|\.)/, "");
  // const match = /(\d{0,7})[^.]*((?:\.\d{0,2})?)/g.exec(val);
  const match = /(\d*)[^.]*((?:\.\d{0,2})?)/g.exec(val);
  const value = match[1] + match[2];
  if (val.length > 0) {
    return (Number(value) / 1000).toFixed(2);
  }
  return (Number(value) / 1000).toFixed(2);
};

const isValidHttpUrl = (str: string) => {
  if (typeof str !== "string") return true;
  if (!str) return true;
  return /^(http|https):\/\/[^ "]+$/.test(str);
};

const dictRegExp = {
  user: /^[\-a-zA-Zа-яёА-ЯЁ0-9\s]*$/, // только буквы и цифры
  digits: /^[0-9]*$/, // только буквы и цифры
  domain:
    /^((http|https):\/\/)?([a-zA-Z0-9-а-яА-Я]{1,61}(\.[a-zA-Zа-яА-Я]{2,})+)+$/, // домен __.__
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

// регулярки для PatternFormField
const fromPatternField = {
  lettersRus: /[^А-Яа-яЁё ]/g,
  lettersLat: /[^a-zA-Z ]/g,
  lettersAndNum: /[^a-zA-Z0-9 ]/g,
  position: /[^a-zA-Z0-9А-Яа-яЁё -]/g,
};

const letter = /[а-яa-z]/i;
const digit = /[0-9]/;
const perhapsDigit = /[0-9\s]/;
// маска для рег.знака автомобиля
const maskRegistrationNumber = [
  letter,
  digit,
  digit,
  digit,
  letter,
  letter,
  digit,
  digit,
  perhapsDigit,
];

const LENGTH_EIS = 36;

const maskEIS = "9".repeat(LENGTH_EIS);
const placeholderMaskEIS = "_";

const getFormatLinkEIS = (str: string | number) => {
  const numberEIS = String(str);
  if (numberEIS?.length) {
    const eis = numberEIS?.replace(/[^\d]/g, "");
    return eis.length === LENGTH_EIS
      ? `https://zakupki.gov.ru/epz/order/extendedsearch/results.html?searchString=${
          eis ?? ""
        }`
      : "";
  }
  return "";
};
export {
  maskRegistrationNumber,
  dictRegExp,
  maskEIS,
  fromPatternField,
  isValidHttpUrl,
  formatedTwoDigitsAfterNum,
  placeholderMaskEIS,
  getFormatLinkEIS,
};
